export default "__VITE_PUBLIC_ASSET__838d341e__"